import { z } from 'zod';

import type { Address } from '@/models/Address.ts';
import type { Contact } from '@/models/Contact.ts';
import type { EntityNote } from '@/models/EntityNote.ts';

import type { Sop } from './Sop';

export const AuthoritySchema = z.object({
  id: z.string(),
  organizationName: z.string(),
  name: z.string(),
  address: z.custom<Address>().nullable().optional(),
  status: z.string(),
  createDate: z.string(),
  updateDate: z.string().nullable().optional(),
  lastUpdateDate: z.string().nullable().optional(),
  contactsCount: z.number().int().nonnegative(),
  connectionsCount: z.number().int().nonnegative().nullable().optional(),
  connectionName: z.string().nullable().optional(),
  contacts: z.array(z.custom<Contact>()),
  entityNotes: z.array(z.custom<EntityNote>()).nullable().optional(),
  tag: z.array(z.record(z.string(), z.string())).nullable().optional(),
  serviceSchemesCount: z.number().int().nonnegative(),
  sopsCount: z.number().int().nonnegative(),
  sop: z.custom<Sop>().nullable().optional(),
});

export type Authority = z.infer<typeof AuthoritySchema>;

export const AuthorityListItemSchema = AuthoritySchema;
export type AuthorityListItem = z.infer<typeof AuthorityListItemSchema>;
